// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","white":"#ffffff","dark-red":"#a30000","light-grey":"#d4d4d4","fastest":".15s","mobile":"480px","linear":"cubic-bezier(0, 0, 1, 1)","link":"_1Kw3LWN7DyhbryUksezfBa","disabled":"_248peY07ilSeUrm0Puyv-A","dark":"iMRsgZZfy80xoggc8gaU","s":"_3v_iXXQquUmuZzEI7K_N4H","m":"M7SFd48oX9i-0_oBbJ-Id","l":"_3fiG7nvEhvq2VPdTZm28cf"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Link/LinkAction/LinkAction.css
// module id = 974
// module chunks = 0